import type { AgentRun, ArtefactReviewItem, PhaseCriteria } from "./types";

/** Resolve the review checklist for one artefact row (deck vs advisor notes, etc.). */
export function artefactCriteriaForItem(
  run: AgentRun,
  artefact: ArtefactReviewItem,
): PhaseCriteria | null {
  const kind = artefact.artifact_kind;
  if (kind && run.artefact_review_criteria_by_kind?.[kind]) {
    return run.artefact_review_criteria_by_kind[kind];
  }
  return run.artefact_review_criteria ?? null;
}

export function runHasReviewableArtefacts(run: AgentRun): boolean {
  const artefacts = run.artefacts ?? [];
  return artefacts.some((artefact) => artefactCriteriaForItem(run, artefact) != null);
}
